<script>
  import getSectorNames from "../../helpers/getSectorNames";
  import findSector from "../../helpers/findSector";
  import FeaturedLinks from "./FeaturedLinks.svelte";
  // Props
  export let report;

  // Constants
  const sectorNames = getSectorNames(report.sectorIds);
  const imgSrc = report.featuredImage?.length
    ? `data:image/jpeg;base64,${report.featuredImage}`
    : null;
  const foundSummaryReport = report.summaryId
    ? WP.summaryIdMap.find((summary) => {
        return summary.id === report.summaryId;
      })
    : null;

  // Use sector image if no image available
  const fullImg =
    !imgSrc && report.sectorIds.length
      ? findSector("id", report.sectorIds[0], "image")
      : null;
</script>

<div class="featured-report">
  {#if imgSrc}
    <img class="featured-report-img" src={imgSrc} alt={report.title} />
  {:else}
    <div class="featured-report-img">{@html fullImg || ""}</div>
  {/if}
  <div>
    {#if sectorNames}
      <p class="featured-report-sector">{sectorNames}</p>
    {/if}

    <h3 class="featured-report-title">{report.title}</h3>

    <FeaturedLinks
      reportLink={report.url}
      summaryLink={foundSummaryReport ? foundSummaryReport.slug : null}
      podcastLink={report.podcastUrl || null}
      compact={true}
    />
  </div>
</div>

<style>
  .featured-report {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 40px;
  }

  .featured-report-img,
  .featured-report-img :global(img) {
    height: 120px;
    width: 186px;
    min-width: 186px;
    object-fit: cover;
    margin-right: 48px;
    background: #f9f9f9;
  }

  .featured-report-sector {
    color: #9b9b9b;
    font-family: "Georgia";
    font-weight: 400;
    font-style: normal;
    font-size: 18px;
    padding: 0;
  }

  .featured-report-title {
    font-family: "Segoe UI", sans-serif;
    font-weight: 600;
    font-style: normal;
    font-size: 18px;
    line-height: 26px;
    color: #3d4042;
    padding-bottom: 0;
  }
  @media screen and (max-width: 580px) {
    .featured-report {
      flex-direction: column;
    }
    .featured-report-img {
      display: none;
    }
  }
</style>
